import { Quotation } from 'data-layer-cr/dist/models';

import {
  EMISSION_METHOD,
  END_DATE,
  NEW_VEHICLE,
  COLLECTIVE_NAME,
  VALUE,
  FINAL_SCREEN_STEP,
  trackCurrentStep,
  trackEvent,
} from 'src/analytics';

const trackConfirmationEvent = (
  emissionMethod: string,
  quotation: Quotation,
): void => {
  trackEvent({
    eventName: FINAL_SCREEN_STEP,
    eventProperties: {
      [END_DATE]: new Date().toLocaleString(),
      [EMISSION_METHOD]: emissionMethod,
      [VALUE]: quotation.units[0].unit.value.toString(),
      [NEW_VEHICLE]: quotation.units[0].unit.isNewCar.toString(),
      [COLLECTIVE_NAME]: quotation.quotationProfile.description,
    },
  });
  trackCurrentStep(FINAL_SCREEN_STEP);
};

export default trackConfirmationEvent;
